module.exports = __webpack_public_path__ + "img/source_05.514cfa33.png";